import { Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { breadcrumbFor } from './navigation'

export function PageHeader({ title }: { title: string }) {
  const { pathname } = useLocation()
  const trail = breadcrumbFor(pathname)

  return (
    <div className="-mx-6 -mt-6 mb-6 flex flex-wrap items-center justify-between gap-2 bg-surface px-6 py-2.5 shadow-card">
      <h4 className="text-15 font-bold uppercase text-white">{title}</h4>
      <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-13">
        <Link to="/dashboard" className="text-white hover:text-primary">Walleon</Link>
        {trail.map((crumb, i) => (
          <Fragment key={`${crumb}-${i}`}>
            <i className="ri-arrow-right-s-line text-muted" aria-hidden />
            <span className={i === trail.length - 1 ? 'text-muted' : 'text-white'}>{crumb}</span>
          </Fragment>
        ))}
      </nav>
    </div>
  )
}
